<!--法律风险-->
<template>
  <div class="risk">
    <!--法律诉讼-->
    <div ref="legal0" class="first-content">
      <div class="title-min SourceHanSansCN">法律诉讼<span class="quota">{{ legalProceedings.length }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <vxe-table resizable border ref="xTable2" :data="legalProceedings" align="center"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号"></vxe-column>
          <vxe-column field="title" title="案件名称">
            <template #default="{row}">
              <el-link type="primary" :underline="false" v-if="row.title" @click="legalProceedingsDetail(row)">
                {{ row.title }}
              </el-link>
              <span v-else>-</span>
            </template>
          </vxe-column>
          <vxe-column field="summaryName" title="案由" width="100"></vxe-column>
          <vxe-column field="caseNumber" title="案号" width="140"></vxe-column>
          <vxe-column field="caseIdentity" title="案件身份"></vxe-column>
          <vxe-column field="caseAmount" title="案件金额(元)" width="130"></vxe-column>
          <vxe-column field="refereeResult" title="裁判结果" align="left" header-align="center"></vxe-column>
          <vxe-column field="dateIssue" title="发布日期" width="120"></vxe-column>
          <vxe-column field="refereeDate" title="裁决日期" width="120"></vxe-column>
          <vxe-column title="操作" width="80">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="legalProceedingsDetail(row)">详情
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--开庭公告-->
    <div ref="legal1" class="essential-content">
      <div class="title-min SourceHanSansCN">开庭公告<span class="quota">{{ openingAnnouncement.length }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <vxe-table resizable border ref="xTable3" :data="openingAnnouncement" align="center"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号"></vxe-column>
          <vxe-column field="caseNumber" title="案号" width="220"></vxe-column>
          <vxe-column field="dateHearing" title="开庭时间" width="120">
            <template #default="{ row }">
              <span>{{ $moment(row.dateHearing).format('YYYY-MM-DD') }}</span>
            </template>
          </vxe-column>
          <vxe-column field="summary" title="案由" width="180"></vxe-column>
          <vxe-column field="plaintiff" title="案件身份" align="left" header-align="center">
            <template #default="{ row }">
              <div v-if="row.plaintiff!='' && row.plaintiff!=null && row.plaintiff!=undefined">
                <span>原告-</span><span>{{ row.plaintiff }}</span></div>
              <div v-if="row.defendant!='' && row.defendant!=null && row.defendant!=undefined">
                <span>被告-</span><span>{{ row.defendant }}</span></div>
            </template>
          </vxe-column>
          <vxe-column title="操作" width="80">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="openAnnouncement(row)">详情
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--法院公告-->
    <div ref="legal2" class="essential-content">
      <div class="title-min SourceHanSansCN">法院公告<span class="quota">{{ courtNotice.length }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <vxe-table resizable border ref="xTable4" :data="courtNotice" align="center"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号"></vxe-column>
          <vxe-column field="caseNumber" title="案号" width="220"></vxe-column>
          <vxe-column field="plaintiff" title="案件身份">
            <template #default="{ row }">
              <div v-if="row.plaintiff!='' && row.plaintiff!=null && row.plaintiff!=undefined">
                <span>原告-</span><span>{{ row.plaintiff }}</span></div>
              <div v-if="row.defendant!='' && row.defendant!=null && row.defendant!=undefined">
                <span>被告-</span><span>{{ row.defendant }}</span></div>
            </template>
          </vxe-column>
          <vxe-column field="noticeType" title="公告类型" width="160"></vxe-column>
          <vxe-column field="announcementType" title="案由" width="180"></vxe-column>
          <vxe-column field="court" title="公告人" width="180"></vxe-column>
          <vxe-column field="publicationDate" title="刊登日期" width="110"></vxe-column>
          <vxe-column title="操作" width="80">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="courtNoticeInfo(row)">详情</el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--送达公告-->
    <div ref="legal3" class="essential-content">
      <div class="title-min SourceHanSansCN">送达公告<span class="quota">{{ serviceNotice.length }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <vxe-table resizable border ref="service" :data="serviceNotice" align="center"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号"></vxe-column>
          <vxe-column field="name" title="公告名称" width="277"></vxe-column>
          <vxe-column field="caseNumber" title="案号" width="198"></vxe-column>
          <vxe-column field="causeAction" title="案由" width="112"></vxe-column>
          <vxe-column field="caseIdentityDetails" title="案件身份" header-align="center" align="left">
            <template #default="{ row }">
              <div style="display: flex;justify-content: left;align-items: baseline;padding-bottom: 10px">
                <div>原告：</div>
                <div>
                  <div v-for="rows of row.caseIdentityDetails" v-if="rows.identityName=='原告'" style="color: #1637FF">{{rows.name}}</div>
                </div>
              </div>
              <div style="display: flex;justify-content: left;align-items: baseline;">
                <div>被告：</div>
                <div>
                  <div v-for="rows of row.caseIdentityDetails" v-if="rows.identityName=='被告'" style="color: #1637FF">{{rows.name}}</div>
                </div>
              </div>
            </template>
          </vxe-column>
          <vxe-column field="dateIssue" title="发布日期" width="110"></vxe-column>
          <vxe-column title="操作" width="70">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="legalAssistanceDetail(row)">详情
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--立案信息-->
    <div ref="legal4" class="essential-content">
      <div class="title-min SourceHanSansCN">立案信息<span class="quota">{{ filingInfo.length }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <vxe-table resizable border ref="xTable6" :data="filingInfo" align="center"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号"></vxe-column>
          <vxe-column field="caseNumber" title="案号" width="240"></vxe-column>
          <vxe-column field="causeAction" title="案由" width="180"></vxe-column>
          <vxe-column field="plaintiff" title="案件身份">
            <template #default="{ row }">
              <div v-if="row.plaintiff!='' && row.plaintiff!=null && row.plaintiff!=undefined">
                <span>上诉人/原告-</span><span>{{ row.plaintiff }}</span></div>
              <div v-if="row.defendant!='' && row.defendant!=null && row.defendant!=undefined">
                <span>被上诉人/被告-</span><span>{{ row.defendant }}</span></div>
            </template>
          </vxe-column>
          <vxe-column field="court" title="法院名称"></vxe-column>
          <vxe-column field="filingDate" title="立案日期" width="110"></vxe-column>
          <vxe-column title="操作" width="80">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="filingInfoDeatil(row)">详情
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--终本案件-->
    <div ref="legal5" class="essential-content">
      <div class="title-min SourceHanSansCN">终本案件<span class="quota">{{ finalCase.detailed.length }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <el-row class="el-row-lightblue">
          <el-col :span="8"><span class="span-red">{{ finalCase.executionTotal }}</span><br/>执行标的总金额</el-col>
          <el-col :span="8"><span class="span-red">{{ finalCase.nonPerformanceTotal }}</span><br/>未履行总金额</el-col>
          <el-col :span="8"><span class="span-red">{{ finalCase.nonPerformanceProp }}</span><br/>未履行比例</el-col>
        </el-row>
        <vxe-table resizable border ref="xTable7" :data="finalCase.detailed" align="left"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="caseNumber" title="案号" width="240"></vxe-column>
          <vxe-column field="implementSubjectMatter" title="执行标的" width="180">
            <template #default="{row}">{{ row.implementSubjectMatter || '-' }}</template>
          </vxe-column>
          <vxe-column field="outstandingAmount" title="未履行金额" width="180">
            <template #default="{row}">{{ row.outstandingAmount || '-' }}</template>
          </vxe-column>
          <vxe-column field="courtExecution" title="执行法院"></vxe-column>
          <vxe-column field="filingDate" title="立案日期" width="110">
            <template #default="{row}">{{ row.filingDate || '-' }}</template>
          </vxe-column>
          <vxe-column field="finalDate" title="终本日期" width="110">
            <template #default="{row}">{{ row.finalDate || '-' }}</template>
          </vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{row}">
              <el-button type="text" style="border: none;background: none;" @click="finalCaseDetail(row)">详情</el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--司法拍卖-->
    <div ref="legal6" class="essential-content">
      <div class="title-min SourceHanSansCN">司法拍卖<span class="quota">{{ judicialAuctionList.length }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <vxe-table resizable border ref="xTable8" :data="judicialAuctionList" align="left"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="auctionTime" title="拍卖时间"></vxe-column>
          <vxe-column field="auctionAnnouncement" title="拍卖公告"></vxe-column>
          <vxe-column field="auctionObject" title="拍卖标的"></vxe-column>
          <vxe-column field="startingPrice" title="起拍价" width="120">
            <template #default="{ row }">{{ row.startingPrice || '-' }}</template>
          </vxe-column>
          <vxe-column field="estPrice" title="评估价" width="120">
            <template #default="{ row }">{{ row.estPrice || '-' }}</template>
          </vxe-column>
          <vxe-column field="auctionStage" title="拍卖阶段" width="110"></vxe-column>
          <vxe-column field="executionCourt" title="委托法院" width="190"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="judicialAuction(row)">详情</el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--限制消费令-->
    <div ref="legal7" class="essential-content">
      <div class="title-min SourceHanSansCN">限制消费令<span class="quota">{{ restrictionConsume.length }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <vxe-table resizable border ref="xTable9" :data="restrictionConsume" align="left"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="filingDate" title="立案日期" width="120">
            <template #default="{ row }">
              <span v-if="row.filingDate">{{ $moment(row.filingDate).format('YYYY-MM-DD') }}</span>
              <span v-else>-</span>
            </template>
          </vxe-column>
          <vxe-column field="caseNumber" title="案号" width="240"></vxe-column>
          <vxe-column field="enterpriseInformation" title="限制消费对象">
            <template #default="{ row }">
              <span v-if="row.enterpriseInformation">{{ row.enterpriseInformation }}</span>
              <span v-else>-</span>
            </template>
          </vxe-column>
          <vxe-column field="name" title="关联限制消费对象" width="180"></vxe-column>
          <vxe-column field="applicant" title="申请人">
            <template #default="{ row }">
              <span v-if="row.applicant">{{ row.applicant }}</span>
              <span v-else>-</span>
            </template>
          </vxe-column>
          <vxe-column field="dateIssue" title="发布日期" width="120">
            <template #default="{ row }">
              <span>{{ $moment(row.dateIssue).format('YYYY-MM-DD') }}</span>
            </template>
          </vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="restrictionConsumeDetail(row)">详情
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--失信信息-->
    <div ref="legal8" class="essential-content">
      <div class="title-min SourceHanSansCN">失信信息<span class="quota">{{ breakPromiseInfo.detailed.length }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <el-row class="el-row-lightblue">
          <el-col :span="8"><span class="span-red">{{ breakPromiseInfo.involvedNum }}</span><br/>涉案总数</el-col>
          <el-col :span="8"><span class="span-red">{{ breakPromiseInfo.nonPerformanceTotal }}</span><br/>全部未履行数量
          </el-col>
          <el-col :span="8"><span class="span-red">{{ breakPromiseInfo.nonPerformanceProp }}</span><br/>未履行比例</el-col>
        </el-row>
        <vxe-table resizable border ref="xTable10" :data="breakPromiseInfo.detailed" align="left"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="filingDate" title="立案日期" width="120"></vxe-column>
          <vxe-column field="caseNumber" title="案号" width="240"></vxe-column>
          <vxe-column field="accordingDocumentNumber" title="执行依据文号" width="240"></vxe-column>
          <vxe-column field="courtExecution" title="执行法院"></vxe-column>
          <vxe-column field="dishonestBehavior" title="失信行为"></vxe-column>
          <vxe-column field="performance" title="履行情况" width="120"></vxe-column>
          <vxe-column field="dateIssue" title="发布日期" width="120"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{row}">
              <el-button type="text" style="border: none;background: none;" @click="dishonestInformation(row)">详情
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--被执行人-->
    <div ref="legal9" class="essential-content">
      <div class="title-min SourceHanSansCN">被执行人<span class="quota">{{ Executee.detailed.length }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <el-row class="el-row-lightblue">
          <el-col :span="24"><span class="span-red">{{ Executee.executeeTotal }}元</span><br/>被执行总金额</el-col>
        </el-row>
        <vxe-table resizable border ref="xTable11" :data="Executee.detailed" align="left"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="filingDate" title="立案日期"></vxe-column>
          <vxe-column field="caseNumber" title="案号"></vxe-column>
          <vxe-column field="executedObject" title="执行标的">
            <template #default="{row}">{{ row.executedObject }}元</template>
          </vxe-column>
          <vxe-column field="courtExecution" title="执行法院"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{row}">
              <el-button type="text" style="border: none;background: none;" @click="executeeDetail(row)">详情</el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--司法协助-->
    <div ref="legal10" class="essential-content">
      <div class="title-min SourceHanSansCN">司法协助<span class="quota">{{ judicialAssistanceList.length }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <vxe-table resizable border ref="judicial" :data="judicialAssistanceList" align="left"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="publicityDate" title="公示日期" width="120" align="center"></vxe-column>
          <vxe-column field="documentNumber" title="执行通知书文号"></vxe-column>
          <vxe-column field="executedPerson" title="被执行人">
            <template #default="{ row }">{{ row.executedPerson.name }}</template>
          </vxe-column>
          <vxe-column field="executedEnterprise" title="股权被执行的企业"></vxe-column>
          <vxe-column field="equityAmount" title="股权数额" width="120"></vxe-column>
          <vxe-column field="executionCourt" title="执行法院"></vxe-column>
          <vxe-column field="type" title="类型" width="120" align="center"></vxe-column>
          <vxe-column field="status" title="状态" width="80" align="center"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="judicialAssistanceDetail(row)">详情
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--询价评估-->
    <div ref="legal11" class="essential-content">
      <div class="title-min SourceHanSansCN">询价评估<span class="quota">{{ inquiryEvaluation.size }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <div class="result-left">询价评估结果 <span class="quota">{{ inquiryEvaluation.inquiryResult.length }}</span></div>
        <vxe-table resizable border ref="xTable13" :data="inquiryEvaluation.inquiryResult" align="left"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="releaseDate" title="发布日期" width="120"></vxe-column>
          <vxe-column field="caseNumber" title="案号"></vxe-column>
          <vxe-column field="courtName" title="法院"></vxe-column>
          <vxe-column field="name" title="被执行人姓名"></vxe-column>
          <vxe-column field="propertyType" title="财产类型" width="120"></vxe-column>
          <vxe-column field="subjectMatterName" title="标的物名称" width="120"></vxe-column>
          <vxe-column field="selectionResults" title="询价结果"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="seePDF(row.details)">详情</el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
      <div style="padding: 0px 0px 20px;">
        <div class="result-left">选定评估机构<span class="quota">{{ inquiryEvaluation.inquiryOrgan.length }}</span></div>
        <vxe-table resizable border ref="xTable14" :data="inquiryEvaluation.inquiryOrgan" align="left"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="lotteryDate" title="摇号日期" width="120"></vxe-column>
          <vxe-column field="caseNumber" title="案号" width="230"></vxe-column>
          <vxe-column field="courtName" title="法院" width="210"></vxe-column>
          <vxe-column field="name" title="当事人姓名" width="190"></vxe-column>
          <vxe-column field="propertyType" title="财产类型" width="105"></vxe-column>
          <vxe-column field="subjectMatterName" title="标的物名称" width="160"></vxe-column>
          <vxe-column field="mechanism" title="选定评估机构">
            <template #default="{ row }">
              <el-link type="primary" :underline="false" v-for="mechanism in row.mechanism.split('、')"
                       @click="introductionView(mechanism)">{{ mechanism }}
              </el-link>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--司法解析-->
    <div ref="legal12" class="essential-content">
      <div class="title-min SourceHanSansCN">司法解析<span class="quota">{{ analysisJudicial.length }}</span></div>
      <div style="padding: 0px 0px 20px;">
        <vxe-table resizable border ref="xTable15" :data="analysisJudicial" align="left"
                   style="margin: 0px 30px;border: 0.5pt solid #e5eef6;">
          <vxe-column type="seq" width="60" title="序号" align="center"></vxe-column>
          <vxe-column field="caseName" title="案件名称"></vxe-column>
          <vxe-column field="caseNumber" title="相关案号" width="240"></vxe-column>
          <vxe-column field="caseSummary" title="案由" width="120"></vxe-column>
          <vxe-column field="caseType" title="案件类型" width="120" align="center"></vxe-column>
          <vxe-column field="caseIdentity" title="案件身份" width="120"></vxe-column>
          <vxe-column field="currentProceedings" title="当前审理程序" width="140"></vxe-column>
          <vxe-column field="currentDate" title="当前程序日期" width="120"></vxe-column>
          <vxe-column title="操作" width="80" align="center">
            <template #default="{ row }">
              <el-button type="text" style="border: none;background: none;" @click="judicialAnalysis(row)">详情
              </el-button>
            </template>
          </vxe-column>
        </vxe-table>
      </div>
    </div>
    <!--PDF文件预览-->
    <el-dialog title="预览" :visible.sync="dialog_pdf" top="0px" width="100%">
      <div :style="'height:'+dialogHeight+'px;'">
        <iframe style="width: 100%;height: 100%" :src="pdfSrc"/>
      </div>
    </el-dialog>
    <!--法院公告详情-->
    <el-dialog title="法院公告详情" :visible.sync="Dialog6">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">刊登日期</td>
          <td class="col-td3">{{ $moment(CourtDeclaredBase.publicationDate).format('YYYY-MM-DD') || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">刊登版面</td>
          <td class="col-td3">{{ CourtDeclaredBase.publicationPage || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">案件身份</td>
          <td class="col-td3">{{ CourtDeclaredBase.party }}</td>
        </tr>
        <tr>
          <td class="col-td1">公告类型</td>
          <td class="col-td3">{{ CourtDeclaredBase.announcementType || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">法院</td>
          <td class="col-td3">{{ CourtDeclaredBase.court || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">法院公告内容</td>
          <td class="col-td3">
            <div v-html="CourtDeclaredBase.detail" v-if="CourtDeclaredBase.detail"></div>
            <span v-else>-</span>
          </td>
        </tr>
      </table>
    </el-dialog>
    <!--开庭公告详情-->
    <el-dialog title="开庭公告详情" :visible.sync="Dialog4">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">案由</td>
          <td class="col-td2" style="width: 85%;">{{ courtNoticeBase.summary || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">案号</td>
          <td class="col-td2">{{ courtNoticeBase.caseNumber || '-' }}</td>
          <td class="col-td1">开庭日期</td>
          <td class="col-td2" v-if="courtNoticeBase.dateHearing">
            {{ $moment(courtNoticeBase.dateHearing).format('YYYY-MM-DD') }}
          </td>
          <td class="col-td2" v-else>-</td>
        </tr>
        <tr>
          <td class="col-td1">承办部门</td>
          <td class="col-td2">{{ courtNoticeBase.undertakingDepartment || '-' }}</td>
          <td class="col-td1">排期日期</td>
          <td class="col-td2" v-if="courtNoticeBase.scheduleDate">
            {{ $moment(courtNoticeBase.scheduleDate).format('YYYY-MM-DD') }}
          </td>
          <td class="col-td2" v-else>-</td>
        </tr>
        <tr>
          <td class="col-td1">许可决定日期</td>
          <td class="col-td2" v-if="courtNoticeBase.licenseDecisionDate">
            {{ $moment(courtNoticeBase.licenseDecisionDate).format('YYYY-MM-DD') }}
          </td>
          <td class="col-td2" v-else>-</td>
          <td class="col-td1">审判长/主审人</td>
          <td class="col-td2">{{ courtNoticeBase.presidingJudge || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">原告</td>
          <td class="col-td2">{{ courtNoticeBase.plaintiff || '-' }}</td>
          <td class="col-td1">被告</td>
          <td class="col-td2">{{ courtNoticeBase.defendant || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">法院</td>
          <td class="col-td2">{{ courtNoticeBase.court || '-' }}</td>
          <td class="col-td1">法庭</td>
          <td class="col-td2">{{ courtNoticeBase.tribunal || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--送达公告详情-->
    <el-dialog title="送达公告详情" :visible.sync="Dialog10">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">公告名称</td>
          <td class="col-td2">{{ NoticeDetails.name || '-' }}</td>
          <td class="col-td1">案号</td>
          <td class="col-td2">{{ NoticeDetails.caseNumber || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">当事人</td>
          <td class="col-td2" style="width: 85%;">{{ NoticeDetails.caseIdentityDetails || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">案由</td>
          <td class="col-td2">{{ NoticeDetails.causeAction || '-' }}</td>
          <td class="col-td1">发布日期</td>
          <td class="col-td2">{{ NoticeDetails.dateIssue || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">原文</td>
          <td class="col-td2" style="width: 85%;">{{ NoticeDetails.content || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--立案信息详情-->
    <el-dialog title="立案信息详情" :visible.sync="Dialog7">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">案号</td>
          <td class="col-td2">{{ filingInformation.caseNumber || '-' }}</td>
          <td class="col-td1">立案日期</td>
          <td class="col-td2">{{ filingInformation.filingDate || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">开庭日期</td>
          <td class="col-td2">{{ filingInformation.dateHearing || '-' }}</td>
          <td class="col-td1">结束日期</td>
          <td class="col-td2">{{ filingInformation.endDate || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">承办部门</td>
          <td class="col-td2">{{ filingInformation.undertakingDepartment || '-' }}</td>
          <td class="col-td1">法院</td>
          <td class="col-td2">{{ filingInformation.court || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">承办法官</td>
          <td class="col-td2">{{ filingInformation.judge || '-' }}</td>
          <td class="col-td1">法官助理</td>
          <td class="col-td2">{{ filingInformation.assistantJudge || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">案件类型</td>
          <td class="col-td2">{{ filingInformation.typesCases || '-' }}</td>
          <td class="col-td1">案件状态</td>
          <td class="col-td2">{{ filingInformation.caseStatus || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">案件身份</td>
          <td class="col-td2" style="width: 85%;">
            <div v-if="filingInformation.plaintiff">
              <span>原告-</span><span>{{ filingInformation.plaintiff }}</span></div>
            <div v-if="filingInformation.defendant">
              <span>被告-</span><span>{{ filingInformation.defendant }}</span></div>
          </td>
        </tr>
      </table>
    </el-dialog>
    <!--终本案件详情-->
    <el-dialog title="终本案件详情" :visible.sync="Dialog8" width="60%">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">被执行人姓名/名称</td>
          <td class="col-td2" style="width: 85%;">{{ finalCaseDetail1.executedPerson || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">案号</td>
          <td class="col-td2">{{ finalCaseDetail1.caseNumber || '-' }}</td>
          <td class="col-td1">身份证号码/组织机构代码</td>
          <td class="col-td2">{{ finalCaseDetail1.organizationNumber || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">执行法院</td>
          <td class="col-td2">{{ finalCaseDetail1.courtExecution || '-' }}</td>
          <td class="col-td1">立案日期</td>
          <td class="col-td2">{{ finalCaseDetail1.filingDate || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">终本日期</td>
          <td class="col-td2">{{ finalCaseDetail1.finalDate || '-' }}</td>
          <td class="col-td1">执行标的</td>
          <td class="col-td2">{{ finalCaseDetail1.implementSubjectMatter || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">未履行金额</td>
          <td class="col-td2" style="width: 85%;">{{ finalCaseDetail1.outstandingAmount || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--司法拍卖详情-->
    <el-dialog title="司法拍卖详情" :visible.sync="Dialog5" width="80%">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">公告名称</td>
          <td class="col-td3">{{ auctionArray.auctionName }}</td>
        </tr>
        <tr>
          <td class="col-td1">拍卖标的</td>
          <td class="col-td3">{{ auctionArray.auctionObject }}</td>
        </tr>
        <tr>
          <td class="col-td1">起拍价</td>
          <td class="col-td3">{{ auctionArray.startingPrice }}</td>
        </tr>
        <tr>
          <td class="col-td1">评估价</td>
          <td class="col-td3">{{ auctionArray.estPrice }}</td>
        </tr>
        <tr>
          <td class="col-td1">拍卖阶段</td>
          <td class="col-td3">{{ auctionArray.auctionStage }}</td>
        </tr>
        <tr>
          <td class="col-td1">委托法院</td>
          <td class="col-td3">{{ auctionArray.executionCourt }}</td>
        </tr>
        <tr>
          <td class="col-td1">拍卖时间</td>
          <td class="col-td3">{{ auctionArray.auctionTime }}</td>
        </tr>
      </table>
      <el-tabs type="card" :stretch="true" v-model="activeName" style="margin-top: 30px;">
        <el-tab-pane label="竞买公告" name="first" style="width: 100%">
          <div v-html="auctionArray.auctionAnnouncement" class="overflow-div"/>
        </el-tab-pane>
        <el-tab-pane label="竞买须知" name="second" style="width: 100%">
          <div v-html="auctionArray.biddingInstructions" class="overflow-div"></div>
        </el-tab-pane>
        <el-tab-pane label="标的物介绍" name="third" style="width: 100%">
          <div v-html="auctionArray.description" class="overflow-div"></div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <!--失信信息详情-->
    <el-dialog title="失信信息详情" :visible.sync="Dialog3" width="70%">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">失信被执行人</td>
          <td class="col-td2">{{ DishonestInfo['失信被执行人'] || '-' }}</td>
          <td class="col-td1">法定代表人</td>
          <td class="col-td2">{{ DishonestInfo['法定代表人'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">执行依据文号</td>
          <td class="col-td2">{{ DishonestInfo['执行依据文号'] || '-' }}</td>
          <td class="col-td1">身份证号码/组织机构代码</td>
          <td class="col-td2">{{ DishonestInfo['身份证号码/组织机构代码'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">案号</td>
          <td class="col-td2">{{ DishonestInfo['案号'] || '-' }}</td>
          <td class="col-td1">做出执行依据单位</td>
          <td class="col-td2">{{ DishonestInfo['做出执行依据单位'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">执行法院</td>
          <td class="col-td2">{{ DishonestInfo['执行法院'] || '-' }}</td>
          <td class="col-td1">被执行人的履行情况</td>
          <td class="col-td2">{{ DishonestInfo['被执行人履行情况'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">立案日期</td>
          <td class="col-td2">{{ DishonestInfo['立案日期'] || '-' }}</td>
          <td class="col-td1">发布日期</td>
          <td class="col-td2">{{ DishonestInfo['发布日期'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">已履行</td>
          <td class="col-td2">{{ DishonestInfo['已履行'] || '-' }}</td>
          <td class="col-td1">未履行</td>
          <td class="col-td2">{{ DishonestInfo['未履行'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">省份</td>
          <td class="col-td2" style="width: 85%;">{{ DishonestInfo['省份'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">失信被执行人行为具体情形</td>
          <td class="col-td2" style="width: 85%;">{{ DishonestInfo['失信被执行人行为具体情形'] || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">生效法律文书确定的义务</td>
          <td class="col-td2" style="width: 85%;">{{ DishonestInfo['生效法律文书确定的义务'] || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--被执行人详情-->
    <el-dialog title="被执行人详情" :visible.sync="Dialog9" width="60%">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">失信被执行人</td>
          <td class="col-td2">{{ ExecutedPersonDetail.executedName || '-' }}</td>
          <td class="col-td1">立案日期</td>
          <td class="col-td2">{{ ExecutedPersonDetail.filingDate || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">案号</td>
          <td class="col-td2">{{ ExecutedPersonDetail.caseNumber || '-' }}</td>
          <td class="col-td1">身份证号码/组织机构代码</td>
          <td class="col-td2">{{ ExecutedPersonDetail.orgCode || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">执行标的</td>
          <td class="col-td2">
            <span v-if="ExecutedPersonDetail.executedObject && ExecutedPersonDetail.executedObject!=0">
              {{ ExecutedPersonDetail.executedObject }}元
            </span>
            <span v-else>-</span>
          </td>
          <td class="col-td1">执行法院</td>
          <td class="col-td2">{{ ExecutedPersonDetail.courtExecution || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--司法协助详情-->
    <el-dialog title="司法协助详情" :visible.sync="Dialog1" width="60%">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">执行法院</td>
          <td class="col-td2">{{ AssistanceDetails.executionCourt || '-' }}</td>
          <td class="col-td1">执行事项</td>
          <td class="col-td2">{{ AssistanceDetails.executiveMatters || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">执行裁定书文号</td>
          <td class="col-td2">{{ AssistanceDetails.rulingDocumentNo || '-' }}</td>
          <td class="col-td1">执行通知书文号</td>
          <td class="col-td2">{{ AssistanceDetails.documentNumber || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">被执行人</td>
          <td class="col-td2">{{ AssistanceDetails.executedPerson || '-' }}</td>
          <td class="col-td1">股权被执行的企业</td>
          <td class="col-td2">{{ AssistanceDetails.executedEnterprise || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">被执行人持有股权、其它投资权益的数额</td>
          <td class="col-td2">{{ AssistanceDetails.amount || '-' }}</td>
          <td class="col-td1">被执行人证件种类</td>
          <td class="col-td2">{{ AssistanceDetails.certificateType || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">被执行人证件号码</td>
          <td class="col-td2">{{ AssistanceDetails.certificateNumber || '-' }}</td>
          <td class="col-td1">冻结期限自</td>
          <td class="col-td2">{{ AssistanceDetails.startTime || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">冻结期限至</td>
          <td class="col-td2">{{ AssistanceDetails.endTime || '-' }}</td>
          <td class="col-td1">冻结期限</td>
          <td class="col-td2">{{ AssistanceDetails.freezePeriod || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">公示日期</td>
          <td class="col-td2" style="width: 85%;">{{ AssistanceDetails.publicityDate || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
    <!--企业基本信息-->
    <el-dialog title="企业基本信息" :visible.sync="dialog_CD">
      <el-row>
        <el-col :span="24">
          <div class="demo-basic--circle" style="float: left;">
            <el-avatar shape="square" fit="scale-down"
                       v-if="dialog_company_details.companyLogo!=null && dialog_company_details.companyLogo!='https://aiqicha.baidu.com//static/pc/photo/logo.png' && dialog_company_details.companyLogo!='http://aiqicha.baidu.com//static/pc/photo/logo.png' && dialog_company_details.companyLogo!='https://aiqicha.baidu.com/static/pc/photo/logo.png' && dialog_company_details.companyLogo!='http://aiqicha.baidu.com/static/pc/photo/logo.png'"
                       style="width: 100%;height: 100%" :src="dialog_company_details.companyLogo"></el-avatar>
            <el-avatar shape="square" fit="scale-down" v-else style="width: 100%;height: 100%">
              <div class="logo-keyword" :style="'background:'+createRandomColor()+''">
                <span v-for="(logo,index) of logoword(dialog_company_details.entLogoWord)" class="logo-word"v-if="index<4">{{
                    logo
                  }}</span>
              </div>
            </el-avatar>
          </div>
          <div style="padding-left: 30px;float: left;width: 80%">
            <div class="userName" style="margin-top: 0px;">{{ dialog_company_details.companyName || '-' }}</div>
            <div class="text-t2">法定代表人：{{ dialog_company_details.name || '-' }}</div>
            <div class="text-t2">统一社会信用代码：{{ dialog_company_details.unifiedSocialCreditCode || '-' }}</div>
            <div class="text-t2">电话：{{ dialog_company_details.telephony || '-' }}</div>
            <div class="text-t2">官网：{{ dialog_company_details.website || '-' }}</div>
            <div class="text-t2">邮箱：{{ dialog_company_details.mailbox || '-' }}</div>
            <div class="text-t2">地址：{{ dialog_company_details.address || '-' }}</div>
            <div CLASS="text-t2" style="line-height: 32px;">简介：{{ dialog_company_details.synopsis || '-' }}</div>
          </div>
        </el-col>
      </el-row>
    </el-dialog>
    <!--司法解析详情-->
    <el-dialog title="司法解析详情" :visible.sync="Dialog2">
      <table class="dialog-table" style="width:100%">
        <tr>
          <td class="col-td1">案号</td>
          <td class="col-td2">{{ JudicialDetails.caseNumber || '-' }}</td>
          <td class="col-td1">执行事项</td>
          <td class="col-td2">{{ JudicialDetails.caseSummary || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">原告</td>
          <td class="col-td2">{{ JudicialDetails.plaintiff || '-' }}</td>
          <td class="col-td1">被告</td>
          <td class="col-td2">{{ JudicialDetails.defendant || '-' }}</td>
        </tr>
        <tr>
          <td class="col-td1">当前审理程序</td>
          <td class="col-td2">{{ JudicialDetails.currentProceedings || '-' }}</td>
          <td class="col-td1">法院</td>
          <td class="col-td2">{{ JudicialDetails.court || '-' }}</td>
        </tr>
      </table>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import page from "@/components/page/pages";
import {
  getLegalProceedingsBycid,
  getCourtNoticeBycid,
  getDdCourtDeclaredBycid,
  serviceNotice,
  getFilingInformationBycid,
  getFinalCase,
  finalCaseTotalAmount,
  getJudicialAuctionByCidList,
  getAllConsumptionRestrictionOrder,
  DishonestInformation,
  getDdExecutedPersonBycid,
  getDdExecutedPersonTotalAmount,
  getJudicialAssistance,
  inquirySelectionResults,
  inquiryEvaluation,
  getJudicial,
  ddCourtDeclaredDetails,
  courtNoticeDetails,
  serviceNoticeDetails,
  filingInformationDetails,
  finalCaseDetails,
  getJudicialAuctionDetails,
  DishonestInformationDetails,
  getDdExecutedPersonByDetails,
  judicialAssistanceDetails,
  getCompanyId,
  getCompanyInfo,
  getJudicialDetails
} from '@/api/enterpriseDetailsApi'

Vue.use(VXETable)
export default {
  name: "legalRisks",
  components: {page},
  props: {
    corpId: {
      type: Number,
      default() {
        return 0
      }
    }
  },
  data() {
    return {
      /*法律诉讼*/
      legalProceedings: [],
      /*开庭公告*/
      openingAnnouncement: [],
      /*法院公告*/
      courtNotice: [],
      /*送达公告*/
      serviceNotice: [],
      /*分页*/
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 30,
      },
      /*立案信息*/
      filingInfo: [],
      /*终本案件*/
      finalCase: {
        executionTotal: '',
        nonPerformanceTotal: '',
        nonPerformanceProp: '',
        detailed: []
      },
      /*司法拍卖*/
      judicialAuctionList: [],
      /*限制消费令*/
      restrictionConsume: [],
      /*失信信息*/
      breakPromiseInfo: {
        involvedNum: 0,
        nonPerformanceTotal: 0,
        nonPerformanceProp: '',
        detailed: []
      },
      /*被执行人*/
      Executee: {
        executeeTotal: '',
        detailed: []
      },
      /*司法协助*/
      judicialAssistanceList: [],
      /*询价评估*/
      inquiryEvaluation: {
        size: 0,
        inquiryResult: [],
        inquiryOrgan: []
      },
      /*PDF预览*/
      dialog_pdf: false,
      pdfSrc: '',
      dialogHeight: document.documentElement.clientHeight - 130,
      /*司法解析*/
      analysisJudicial: [],
      /*法院公告详情*/
      CourtDeclaredBase: {},
      Dialog6: false,
      /*开庭公告详情*/
      courtNoticeBase: {},
      Dialog4: false,
      /*司法协助详情*/
      NoticeDetails: {},
      Dialog10: false,
      /*立案信息详情*/
      filingInformation: {},
      Dialog7: false,
      /*终本案件详情*/
      finalCaseDetail1: {},
      Dialog8: false,
      /*司法拍卖详情*/
      auctionArray: {},
      Dialog5: false,
      /*失信信息详情*/
      DishonestInfo: {},
      Dialog3: false,
      /*被执行人详情*/
      ExecutedPersonDetail: {},
      Dialog9: false,
      /*司法协助详情*/
      AssistanceDetails: {},
      Dialog1: false,
      /*企业/公司/机构的相关信息*/
      dialog_company_details: {},
      dialog_CD: false,
      /*司法解析详情*/
      JudicialDetails: {},
      Dialog2: false,
      activeName:'first',
    }
  },
  computed: {
    logoword() {
      return function (word) {
        if (word)
          return word.split('');
        else
          return [];
      }
    }
  },
  methods: {
    /*随机生成颜色值*/
    createRandomColor() {
      let num = Math.floor(Math.random() * 9 + 1);
      let colorList = ['#7db3d9', '#d1ae9d', '#ca8484', '#bc9edd', '#8B658B', '#B22222', '#27408B', '#008B8B', '#5D478B', '#68228B'];
      console.log(colorList[num])
      return colorList[num];
    },
    /*法律诉讼*/
    getLegalProceedings() {
      getLegalProceedingsBycid({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.legalProceedings = res.content.rows;
          // console.log(res.content);
        }
      })
    },
    /*获取开庭公告*/
    getCourtNotice() {
      getCourtNoticeBycid({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.openingAnnouncement = res.content.courtNoticePageList.rows;
          // console.log(res.content);
        }
      })
    },
    /*法院公告*/
    getDdCourtDeclared() {
      getDdCourtDeclaredBycid({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.courtNotice = res.content.courtDeclaredPageList.rows;
          // console.log(res.content);
        }
      })
    },
    /*送达公告*/
    getServiceNotice() {
      serviceNotice({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          for (let a of res.content.rows){
            a.caseIdentityDetails=JSON.parse(a.caseIdentityDetails);
          }
          this.serviceNotice = res.content.rows;
          console.log('送达公告',res.content);
        }
      })
    },
    /*立案信息*/
    getFilingInformation() {
      getFilingInformationBycid({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.filingInfo = res.content.projectList.rows;
          // console.log(res.content);
        }
      })
    },
    /*终本案件*/
    getFinalCaseBase() {
      /*获取终本案件列表*/
      getFinalCase({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.finalCase.detailed = res.content.rows;
          // console.log(res.content);
        }
      })
      /*获取终本案件执行标的总金额/未履行总金额/比例*/
      finalCaseTotalAmount({cid: this.corpId, request: 'form'}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          this.finalCase.executionTotal = res.content.implementTotalAmount;
          this.finalCase.nonPerformanceTotal = res.content.nonPerformance;
          this.finalCase.nonPerformanceProp = res.content.proportion;
        }
      })
    },
    /*司法拍卖*/
    getJudicialAuction() {
      getJudicialAuctionByCidList({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.judicialAuctionList = res.content.rows;
          // console.log(res.content);
        }
      })
    },
    /*限制消费令*/
    getAllConsumptionRestrictionOrderBase() {
      getAllConsumptionRestrictionOrder({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.restrictionConsume = res.content.rows;
          // console.log(res.content);
        }
      })
    },
    /*失信信息*/
    getDishonestInformation() {
      DishonestInformation({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          this.breakPromiseInfo.detailed = res.content.pageList.rows;
          this.breakPromiseInfo.nonPerformanceProp = res.content.proportion;
          this.breakPromiseInfo.nonPerformanceTotal = res.content.non_performance_num;
          this.breakPromiseInfo.involvedNum = res.content.total;
        }
      })
    },
    /*被执行人*/
    getDdExecutedPerson() {
      getDdExecutedPersonBycid({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          this.Executee.detailed = res.content.projectList.rows;
        }
      })
      getDdExecutedPersonTotalAmount({cid: this.corpId, request: 'form'}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          this.Executee.executeeTotal = res.content;
        }
      })
    },
    /*司法协助*/
    getJudicialAssistanceBase() {
      getJudicialAssistance({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          res.content.rows.forEach(function (row, index) {
            if (row.executedPerson != '' && row.executedPerson != null && row.executedPerson != undefined) {
              row.executedPerson = JSON.parse(row.executedPerson.replace("\\u005c", ""));
            }
          })
          this.judicialAssistanceList = res.content.rows;
        }
      })
    },
    /*询价评估*/
    getInquirySelectionResults() {
      /*询价评估结果*/
      inquirySelectionResults({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          this.inquiryEvaluation.inquiryResult = res.content.rows;
          this.inquiryEvaluation.size += res.content.rows.length;
        }
      })
      /*选定评估机构*/
      inquiryEvaluation({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          // console.log(res.content);
          this.inquiryEvaluation.inquiryOrgan = res.content.rows;
          this.inquiryEvaluation.size += res.content.rows.length;
        }
      })
    },
    /*司法解析*/
    getJudicialBase() {
      getJudicial({cid: this.corpId, page: 1, request: 'form'}).then(res => {
        if (res.code == 200) {
          console.log(res.content);
          this.analysisJudicial = res.content.rows;
        }
      })
    },
    /*法律诉讼详情*/
    legalProceedingsDetail(row) {
      this.$router.push({path: '/enterpriseDetails/legalProceedingsDetail?id=' + row.id + '&corpId=' + this.corpId});
    },
    /*开庭公告详情*/
    openAnnouncement(row) {
      courtNoticeDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.courtNoticeBase = res.content;
          this.Dialog4 = true;
        }
      })
    },
    /*法院公告详情*/
    courtNoticeInfo(row) {
      ddCourtDeclaredDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.CourtDeclaredBase = res.content;
          this.Dialog6 = true;
        }
      })
    },
    /*司法协助详情*/
    legalAssistanceDetail(row) {
      serviceNoticeDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.NoticeDetails = res.content;
          this.Dialog10 = true;
        }
      })
    },
    /*立案信息详情*/
    filingInfoDeatil(row) {
      filingInformationDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.filingInformation = res.content;
          this.Dialog7 = true;
        }
      })
    },
    /*终本案件详情*/
    finalCaseDetail(row) {
      finalCaseDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.finalCaseDetail1 = res.content;
          this.Dialog8 = true;
        }
      })
    },
    /*司法拍卖详情*/
    judicialAuction(row) {
      getJudicialAuctionDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.auctionArray = res.content;
          this.Dialog5 = true;
        }
      })
    },
    /*限制消费令详情*/
    restrictionConsumeDetail(row) {
      this.$router.push({path: '/enterpriseDetails/limitedConsumption?id=' + row.id + '&corpId=' + this.corpId});
    },
    /*失信信息详情*/
    dishonestInformation(row) {
      DishonestInformationDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          if (res.content != '') {
            let arr = res.content.details;
            if (arr.indexOf('\r\n') > -1) {
              let arr1 = arr.replace(/\r\n/g, "")
              let arr2 = JSON.parse(arr1.replace("\\u005c", ""))
              this.DishonestInfo = arr2;
            } else {
              let arr2 = JSON.parse(arr.replace("\\u005c", ""));
              this.DishonestInfo = arr2;
            }
            this.Dialog3 = true;
          }
        }
      })
    },
    /*被执行人详情*/
    executeeDetail(row) {
      getDdExecutedPersonByDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.ExecutedPersonDetail = res.content;
          this.Dialog9 = true;
        }
      })
    },
    /*司法协助详情*/
    judicialAssistanceDetail(row) {
      judicialAssistanceDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          if (res.content.executedPerson)
            res.content.executedPerson = JSON.parse(res.content.executedPerson.replace("\\u005c", "")).name;
          this.AssistanceDetails = res.content;
          this.Dialog1 = true;
        }
      })
    },
    /*PDF文件预览*/
    seePDF(url) {
      if (url != '' && url != null && url != undefined) {
        this.pdfSrc = url;
        this.dialog_pdf = true;
      } else {
        this.$message({message: '暂无展现数据！', type: 'warning'});
      }
    },
    /**
     * 根据公司/机构/企业名称获取对应的id，
     * 再通过获取到的id去查询企业/公司/机构的相关信息
     */
    introductionView(name) {
      getCompanyId({companyName: name, request: 'form'}).then(res => {
        if (res.code == 200) {
          getCompanyInfo({id: res.content, request: 'form'}).then(obj => {
            if (obj.code == 200) {
              this.dialog_CD = true;
              this.dialog_company_details = obj.content;
            }
          })
        }
      })
    },
    /*司法解析详情*/
    judicialAnalysis(row) {
      getJudicialDetails({id: row.id, request: 'form'}).then(res => {
        if (res.code == 200) {
          this.JudicialDetails = res.content;
          this.Dialog2 = true;
        }
      })
    },
    /*定位到指定位置*/
    scrollToArea(ref) {
      window.scrollTo(0, this.$refs[ref].offsetTop - 200);
    },
  },
  mounted() {
    this.getLegalProceedings();
    this.getCourtNotice();
    this.getDdCourtDeclared();
    this.getServiceNotice();
    this.getFilingInformation();
    this.getFinalCaseBase();
    this.getJudicialAuction();
    this.getAllConsumptionRestrictionOrderBase();
    this.getDishonestInformation();
    this.getDdExecutedPerson();
    this.getJudicialAssistanceBase();
    this.getInquirySelectionResults();
    this.getJudicialBase();
  }
}
</script>
<style lang="scss" scoped>
.risk {
  .first-content {
    background: white;
  }

  .essential-content {
    background: white;
    margin-top: 10px;
    padding-bottom: 20px;

    .span-red {
      color: #FE273B;
      font-weight: bold
    }

    .el-row-lightblue {
      background: #F1F7FC;
      padding: 30px 0px;
      text-align: center;
      margin: 0px 30px 10px;
    }

    .result-left {
      margin-bottom: 15px;
      color: #222222;
      font-size: 16px;
      padding: 0px 30px;
    }
  }

  .quota {
    padding-left: 10px;
    color: #2B79FE;
  }

  .title-min {
    padding: 20px 30px;
    font-size: 16px;
    font-weight: bold;
    color: #222222;
  }

  .logo-keyword {
    height: 170px;
    width: 170px;
    font-size: 48px;
    color: #ffffff;
    font-weight: 500;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0px;

    .logo-word {
      width: 34%;
      height: 34%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .legal {
    height: 60px;
    width: 60px;
    font-size: 18px;
    color: #ffffff;
    font-weight: 500;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    margin: 0px;

    .logo-word {
      width: 34%;
      height: 34%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .el-avatar {
    background: white;
    border: 1px solid rgba(0, 0, 0, .05);
    border-radius: 6px;
    height: 50px;
    width: 50px;
    line-height: 48px;
    float: left;
    color: #333333;
  }

  .none-content {
    margin: 10px 30px 20px;
    height: 120px;
    text-align: center;
    line-height: 120px;
    border: 1px solid #EEEEEE;
    background: #ffffff;
  }

  .dialog-table {
    display: grid;
    border-spacing: 0px;

    tr {
      border: 0.5pt solid #e5eef6;
    }

    .col-td1 {
      padding: 15px 10px 15px 20px;
      background: #D6E9FF;
      text-align: left;
      color: #333333;
      width: 110px;
      border-spacing: 0px;
    }

    .col-td2 {
      padding: 15px 10px;
      background: #ffffff;
      text-align: left;
      width: 35%;
      border-spacing: 0px;
    }

    .col-td3 {
      padding: 15px 10px;
      background: #ffffff;
      text-align: left;
      width: auto;
      border-spacing: 0px;
    }
  }

  .el-dialog__wrapper {
    z-index: 9999 !important;
  }

  .overflow-div {
    font-size: 16px;
    max-height: 500px;
    overflow-y: auto;
    min-height: 300px;
  }

  .text-t2 {
    font-size: 12pt;
    color: #333333;
    margin-top: 10px;
  }

  .userName {
    font-size: 20pt;
    color: #333333;
    margin-top: 30px;
    font-weight: bold;
  }
}
</style>